// extracted by mini-css-extract-plugin
export var avatarContainer = "_hg-0";
export var avatarTypingWave = "_hg-i";
export var gray = "_hg-f";
export var green = "_hg-c";
export var icon = "_hg-9";
export var image = "_hg-1";
export var lg = "_hg-6";
export var md = "_hg-5";
export var presenceDot = "_hg-b";
export var red = "_hg-d";
export var sm = "_hg-4";
export var status = "_hg-a";
export var typingDot = "_hg-h";
export var typingPill = "_hg-g";
export var xl = "_hg-7";
export var xs = "_hg-3";
export var xxl = "_hg-8";
export var xxs = "_hg-2";
export var yellow = "_hg-e";